import { render } from "./Footer.vue?vue&type=template&id=f18a3a80"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=f18a3a80&lang=scss"
script.render = render

export default script